import Button from '@mui/material/Button';
import { KeyedObject } from 'types';

const CustomBtn = (props: KeyedObject) => {
    const { label, sx, variant = 'contained', onPress, disabled, component, href, fullWidth } = props;
    return (
        <Button
            variant={variant}
            fullWidth={fullWidth}
            LinkComponent={component}
            disabled={disabled}
            href={href}
            target="_blank"
            sx={{
                width: '100%',
                height: '58px',
                padding: '18px',
                fontWeight: '600',
                borderRadius: '12px',
                fontSize: '16px',
                ...sx
            }}
            onClick={onPress}
        >
            {label}
        </Button>
    );
};

export default CustomBtn;
